module.exports = "/img/honda.842abd50.png";